import { Reason } from 'api-clients/monolith';

export const defaultReason: Reason = {
  content: 'Other Reason', // might need to be translated in future
  id: null,
};
